/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Table, Grid, Panel } from 'react-bootstrap';
import { routerActions } from 'react-router-redux';
import { format } from 'date-fns';
import Toolbar from 'loracoms/Toolbar';
import IntlMsg from 'lorautils/intl/IntlMsg';
import gatewayActions from 'loraactions/gateway';
import Nvl from 'loracoms/Nvl';
import { normalizeDevEUI } from 'lorautils/IdUtils';
import TablePager from 'loracoms/TablePager';
import ShowIf from 'loracoms/ShowIf';
import SearchInput from 'loracoms/SearchInput';
import callAPI from '@/api/callAPI';
import styles from './styles.scss';

const kLimit = 20;
const kFormat = 'YYYY-MM-DD HH:mm:ss';
const kNodeHeaderTitle = [
  { title: '全部', value: 'allnodes' },
  { title: '功图', value: 'workmapnodes' },
  { title: '压力', value: 'pressnodes' },
  { title: '电参', value: 'electrinodes' },
  { title: '温度', value: 'tempnodes' },
];

const propTypes = {
  intl: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  gatewayDetail: PropTypes.object.isRequired,
  pushState: PropTypes.func.isRequired,
  replaceState: PropTypes.func.isRequired,
  getGateway: PropTypes.func.isRequired,
};

class NodeList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gatewayDetail: props.gatewayDetail,
    };
    this.allNodes = [];
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.node');
    this.handlePaging = this.handlePaging.bind(this);
  }

  componentDidMount() {
    const { getGateway, id } = this.props;
    getGateway(id);
    this.handleTitle();
    this.loadStatus();
  }

  componentWillReceiveProps({ gatewayDetail }) {
    if (!_.isEqual(gatewayDetail, this.props.gatewayDetail)) {
      this.setState({ gatewayDetail });
    }
  }

  loadStatus() {
    const { type, id } = this.props;
    callAPI({
      endpoint: `/tdmng/gateways/${id}/status`,
    }).then((res) => {
      const { liveness = [] } = res || {};
      const nodeTitle = _.find(kNodeHeaderTitle, { value: type });
      const { title } = nodeTitle || {};
      let allNodes = liveness;
      if (title !== '全部') {
        allNodes = _.filter(liveness, l => l.type === title);
      }
      this.allNodes = _.cloneDeep(allNodes);
      let more = false;
      if (allNodes.length > kLimit) { more = true; }
      const showNodes = _.slice(allNodes, 0, kLimit);
      this.setState({ loadStatus: 'success', allNodes, showNodes, more, mark: kLimit });
    }).catch(() => {});
  }

  handleTitle() {
    const { type } = this.props;
    const node = _.find(kNodeHeaderTitle, { value: type });
    const { title } = node || {};
    this.setState({ nodeTitle: title });
  }

  handlePaging(page) {
    const { allNodes } = this.state;
    let showNodes = _.slice(allNodes, 0, kLimit);
    let mark = kLimit;
    if (_.isInteger(page)) {
      mark = page + kLimit;
      showNodes = _.slice(allNodes, page, mark);
    }
    let more = false;
    if (allNodes.length > mark) {
      more = true;
    }
    this.setState({ showNodes, mark, more });
  }

  handleSearch(e) {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    let value = e.target.value;
    if (value.length > 0) {
      value = value.replace(/[:-]/g, '');
    }
    this.searchTimer = _.delay(() => {
      let { allNodes } = this.state;
      if (value !== '') {
        allNodes = _.filter(this.allNodes, a => a.node.indexOf(value) > -1);
      } else {
        allNodes = this.allNodes;
      }
      let more = false;
      if (allNodes.length > kLimit) { more = true; }
      const showNodes = _.slice(allNodes, 0, kLimit);
      this.setState({
        allNodes,
        showNodes,
        more,
        mark: kLimit,
        reset: new Date().valueOf(),
      });
    }, 250);
  }

  render() {
    const { pushState, replaceState, id } = this.props;
    const {
      nodeTitle,
      gatewayDetail: { status, data = {} } = {},
      showNodes = [],
      loadStatus,
      mark,
      reset,
      search,
      more = false,
    } = this.state;

    const tbody = _.map(showNodes, n => (
      <tr>
        <td>
          <Link onClick={() => pushState(`/network/tdm/node/${n.node}`)}>
            {normalizeDevEUI(n.node)}
          </Link>
        </td>
        <td>{n.type}</td>
        <td>
          {!_.isNil(n.lastatt) && n.lastatt !== 0 ? format(n.lastatt, kFormat) : '--'}
        </td>
        <td>
          {!_.isNil(n.lastup) && n.lastup !== 0 ? format(n.lastup, kFormat) : '--'}
        </td>
        <td>
          {!_.isNil(n.lastdn) && n.lastdn !== 0 ? format(n.lastdn, kFormat) : '--'}
        </td>
      </tr>
    ));

    const breadcrumb = [{
      onClick: () => replaceState('/network/tdm'),
      content: 'TDM',
    }, {
      onClick: () => pushState(`/network/tdm/gateway/${id}`),
      content: <Nvl status={status} val={data.name} />,
    }, {
      content: nodeTitle,
      active: true,
    }];

    return (
      <Grid fluid>
        <div>
          <Toolbar breadcrumb={breadcrumb} />
        </div>
        <Panel bsStyle="aisz-white">
          <div className={styles.nodeSearch}>
            <SearchInput
              value={search}
              placeholder={this.intlMsg.msg('search.placeholder')}
              onChange={e => this.handleSearch(e)}
            />
          </div>
          <Table className="aisz-table-light" striped>
            <thead>
              <tr>
                <th>DevEUI</th>
                <th>{this.intlMsg.msg('nodetype')}</th>
                <th>{this.intlMsg.msg('status.lastatt')}</th>
                <th>{this.intlMsg.msg('status.lastup')}</th>
                <th>{this.intlMsg.msg('status.lastdn')}</th>
              </tr>
            </thead>
            <tbody>
              {tbody}
            </tbody>
          </Table>
          <ShowIf if={loadStatus === 'success' && !tbody.length}>
            <div className={styles.noData}>暂无数据</div>
          </ShowIf>
          <div className={styles.pager}>
            <TablePager
              status={loadStatus}
              mark={mark}
              more={more}
              reset={reset}
              onPrev={this.handlePaging}
              onNext={this.handlePaging}
            />
          </div>
        </Panel>
      </Grid>
    );
  }
}

NodeList.propTypes = propTypes;

const mapStateToProps = (state, { params: { id, type } }) => ({
  id,
  type,
  gatewayDetail: state.gateway.gateway,
});

const mapDispatchToProps = ({
  getGateway: gatewayActions.gateway,
  pushState: routerActions.push,
  replaceState: routerActions.replace,
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(NodeList));





// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/GatewayStatus/NodeList.jsx